const isAndroid = ()=> {
  return navigator.userAgent.toLowerCase().includes('android')
}

export default isAndroid
